import { render, staticRenderFns } from "./CloseUserAccount.vue?vue&type=template&id=3d368e5e&scoped=true"
import script from "./CloseUserAccount.vue?vue&type=script&lang=js"
export * from "./CloseUserAccount.vue?vue&type=script&lang=js"
import style0 from "./CloseUserAccount.vue?vue&type=style&index=0&id=3d368e5e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d368e5e",
  null
  
)

export default component.exports